import { WorkOrderCreate } from './WorkOrderCreate';
import { WorkOrderEdit } from './WorkOrderEdit';
import { WorkOrderList } from './WorkOrderList';
import { WorkOrderShow } from './WorkOrderShow';

export const work_orders = {
    list: WorkOrderList,
    create: WorkOrderCreate,
    edit: WorkOrderEdit,
    show: WorkOrderShow,
};
